import { makeStyles } from "@material-ui/core"

const useDefaultStyles = makeStyles(() => ({
	invisibleDividerLarge: {
		backgroundColor: "transparent",
		height: "34px"
	},
	invisibleDividerMedium: {
		backgroundColor: "transparent",
		height: "24px"
	},
	invisibleDividerSmall: {
		backgroundColor: "transparent",
		height: "10px"
	},
	invisibleVerticalDividerSmall: {
		backgroundColor: "transparent",
		width: "10px"
	},
	invisibleVerticalDividerMedium: {
		backgroundColor: "transparent",
		width: "24px"
	},
	buttonBlock: {
		width: "100%"
	},
	centeredTypography: {
		textAlign: "center"
	},
	rightedTypography: {
		textAlign: "right"
	},
	container: {
		padding: "20px",
		display: "flex",
		flexDirection: "column"
	},
	infoSnackbar: {
		backgroundColor: "#fffbe6 !important",
		border: "1px solid #ffe58f",
		color: "rgba(0, 0, 0, 0.85) !important"
	}
}))

export default useDefaultStyles
